import React, { useState, useEffect, useContext } from 'react';
import { Container, TextField, Button, Box, Paper, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as endPoints from '../assets/js/endpoints';
import Loader from '../components/loader';
import { UserContext } from '../assets/contexts/userContext';
import { useNotification } from '../assets/contexts/notificationContext';
import { Helmet } from 'react-helmet';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


const CreateClient = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(!!id); // Si hay ID, cargamos los datos del cliente
  const [form, setForm] = useState({
    name: '',
    apellidos: '',
    direccion: '',
    ciudad: '',
    cp: '',
    email: '',
    telefono: '',
    observaciones: '',
  });

  useEffect(() => {
    if (id) {
      setLoading(true);
      endPoints.getClient(id)
        .then(data => {
          setForm({
            name: data.name || '',
            apellidos: data.apellidos || '',
            direccion: data.direccion || '',
            ciudad: data.ciudad || '',
            cp: data.cp || '',
            email: data.email || '',
            telefono: data.telefono || '',
            observaciones: data.observaciones || '',
          });
        })
        .catch(err => {
          showNotification('Error cargando cliente', 'error');
        })
        .finally(() => setLoading(false));
    }
  }, [id]);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      if (id) {
        await endPoints.updateClient(id, form);
        showNotification('Cliente actualizado', 'success');
      } else {
        await endPoints.createClient(form);
        showNotification('Cliente creado', 'success');
      }
      user.hasRole('admin') ? navigate('/admin/manageClients') : navigate('/employee/clientes');
    } catch (err) {
      const msg = err.response?.data?.error || 'Error guardando cliente';
      showNotification(msg, 'error');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <>
      <Helmet>
        <title>{id ? 'Actualizar Cliente' : 'Crear Cliente'} | CES</title>
      </Helmet>
      <Container sx={{ mt: 5, pb: 2, mb: 2 }}>
        <Box sx={{ display:'flex', justifyContent:'flex-end', mb:2, maxWidth: 800, mx: 'auto' }}>
            <Button variant="contained" startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>Volver</Button>
          </Box>
        <Paper sx={{ p: 3, maxWidth: 800, mx: 'auto' }}>
          
          <Typography variant="h5" gutterBottom sx={{ mb: 3}}>
            {id ? 'Actualizar Cliente' : 'Crear Cliente'}
          </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: 'grid',
            gap: 2,
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
            maxWidth: 750,
            mx: 'auto',
          }}
        >
        <TextField label="Nombre" name="name" value={form.name} onChange={handleChange} required />
        <TextField label="Apellidos" name="apellidos" value={form.apellidos} onChange={handleChange} required />
        <TextField label="Email" name="email" type="email" value={form.email} onChange={handleChange} />
        <TextField label="Teléfono" name="telefono" value={form.telefono} onChange={handleChange} />
        <TextField label="Dirección" name="direccion" value={form.direccion} onChange={handleChange} />
        <TextField label="Ciudad" name="ciudad" value={form.ciudad} onChange={handleChange} />
        <TextField label="CP" name="cp" value={form.cp} onChange={handleChange} />
        
        <TextField
          label="Observaciones"
          name="observaciones"
          value={form.observaciones}
          onChange={handleChange}
          multiline
          rows={3}
          sx={{ gridColumn: '1 / -1', }}
        />
         <Box  sx={{
             gridColumn: '1 / -1',       // abarca desde la columna 1 hasta la última
             display: 'flex',            // usa flexbox para centrar
              justifyContent: 'center',   // centra horizontalmente
              }}>
        <Button type="submit" variant="contained" sx={{ mt: 2, display: 'block', mx: 'auto' }}>
          {id ? 'Actualizar' : 'Crear'} Cliente
        </Button>
       </Box>
        </Box>

        </Paper>
      </Container>
    </>
  );
};

export default CreateClient;
